import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { LinkToPage } from "../components/LinkToPage";
import { ServicePageWrapper } from "styling/ServicePagesStyling";

export const Equality = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Jämställdhetspolicy</title>
        <meta
          name="description"
          content="Vi hjälper ert företag att skapa eller se över er befintliga diskrimineringspolicy och 
          jämställdhetspolicy."
        />
        <meta property="og:title" content="We Exist - Jämställdhetspolicy" />
        <meta
          property="og:description"
          content="Vi hjälper ert företag att skapa eller se över er befintliga diskrimineringspolicy och 
          jämställdhetspolicy."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Jämställdhetspolicy" />
      <ServicePageWrapper>
        <img src="./service-images/jamstalldhetspolicy.jpg" alt="kvinna" />
        <p>
          Hur säkerställer ni att ni jobbar jämställt och inkluderande för alla
          på bolaget? Med en jämställdhets- och diskrimineringspolicy får ni
          trygga ramar att hålla er inom och vet hur ni ska skapa en arbetsplats
          där alla trivs och känner sig trygga samt hur ni ska agera om någon
          situation skulle uppstå. Vi erbjuder att antingen att se över er
          befintliga policy och göra den We Exist Approved eller tar fram en
          helt ny. Därefter kommer vi tillsammans också titta på hur ni ska
          implementera arbetet eftersom action is everything!
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
